import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Access type of the user's role: "Management" or "Employee"
export const getUserAccessType = async (userId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/userRole/getUserAccessType/${userId}`,
    );
    return response.data.accessType;
  } catch (error) {
    throw error;
  }
};
